import axios from 'axios'
import firebaseConfig from 'configs/FirebaseConfig'
import { getAuth } from 'firebase/auth'
const getToken = async () => {
  if (getAuth()?.currentUser) {
    return (await getAuth().currentUser.getIdTokenResult()).token
  } else {
    return null
  }
}

const axiosMDNA = axios.create({
  baseURL: `https://${process.env.REACT_APP_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/IGUserManagement1/v1/`,
})

axiosMDNA.interceptors.request.use(
  async (config) => {
    const token = await getToken()
    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `Bearer ${token}`,
        userId: getAuth()?.currentUser?.uid,
        'Content-Type': 'application/json',
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosMDNA.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

const axiosEnrollment = axios.create({
  baseURL: `https://${process.env.REACT_APP_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/IGUserManagementWebEnrollment/v1/`,
})

const axiosMDNAv2 = axios.create({
  baseURL: `https://${process.env.REACT_APP_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/IGUserManagement/v1/`,
})

axiosMDNAv2.interceptors.request.use(
  async (config) => {
    const token = await getToken()
    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `Bearer ${token}`,
        userId: getAuth()?.currentUser?.uid,
        'Content-Type': 'application/json',
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export { 
  axiosMDNA,
  axiosEnrollment,
  axiosMDNAv2
 }
